import ui from "./_ui";
import m from "./_m";
import message from "./_message";
import error from "./_error";

export default {
  ui: ui,
  message: message,
  error: error,
  m: m
};
